import React from 'react';
import Header from './Header.jsx'
import LegalDocument from './LegalDocument.jsx'
import { TERMS } from './legalContent'
import './Content.scss'

class TermsOfUse extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="content">
          <LegalDocument doc={TERMS} />
        </div>
      </>
    )
  }
}

export default TermsOfUse;
